import { PERMS } from '../permissions/permissionKeys';

export const ROUTE_GATES: Record<string, readonly string[]> = {
  '/dashboard/reservation-ledger': [PERMS.reservation.ledger.list],
  '/dashboard/sales-performance': [PERMS.sales.analytics, PERMS.sales.performance],
  '/dashboard/conversion-analytics': [
    PERMS.conversion.overview,
    PERMS.conversion.store.activity,
    PERMS.conversion.store.list,
    PERMS.conversion.store.performance,
  ],
  '/dashboard/referral-reports': [PERMS.affiliate.referral.report.view, PERMS.referral.customerReport.read],

  '/users/roles': [PERMS.role.type.list],
  '/users/affiliates': [PERMS.affiliate.list],
  '/users/admin': [PERMS.staff.list],
  '/users/customers': [PERMS.customer.list],
  '/users/store-owners': [PERMS.storeOwner.list],

  '/configuration-management/location': [PERMS.location.list],
  '/configuration-management/hoslog-plans': [PERMS.plan.list],
  '/configuration-management/charges': [PERMS.charge.management.list],
  '/configuration-management/withdrawals-setup': [PERMS.withdrawal.setup.list, PERMS.withdrawal.customer.list],
  '/configuration-management/commissions': [PERMS.commission.category.list],
  '/configuration-management/group-management': [PERMS.group.list],
  '/configuration-management/discount-management': [PERMS.discount.category.list],

  '/store-information/premium-stores': [PERMS.club.premium.list],
  '/store-information/basic-stores': [PERMS.club.basic.list],
  '/store-information/premium-stores/plan-management': [PERMS.club.premium.plan.list],
  '/store-information/basic-stores/switch-store': [PERMS.club.switch],
  '/store-information/switch-store': [PERMS.club.switch],
  '/points-management/points-configuration': [PERMS.point.management.list, PERMS.point.management.customer.list],
  '/logs-management/api-logs': [PERMS.api.message.list],
  '/logs-management/email-logs': [PERMS.email.log.list],
  '/logs-management/sms-logs': [PERMS.sms.log.list],
  '/logs-management/static-data-type': [PERMS.static.dataType.list],

  '/faq/review-ratings': [PERMS.reviewRatings.list],
  '/faq/inquiry': [PERMS.inquiry.list],

  '/recommendation-management/main-page': [PERMS.recommendation.mainPage.group.get],
  '/recommendation-management/editors-pick': [PERMS.recommendation.editorPick.read],
  '/promos-offer/promotional-banner': [PERMS.promotionalBanner.list],
  '/account/profile': [PERMS.account.profile.read],
  '/payment-management/admin-payment-setup': [PERMS.paymentManagement.adminPaymentSetup.view],
  '/payment-management/admin-payment-setup/add-bank-information': [PERMS.paymentManagement.adminPaymentSetup.manage],
  '/payment-management/overview': [PERMS.paymentManagement.overview.view],
  '/payment-management/store-payment-log': [PERMS.paymentManagement.storePaymentLogs.list],
  '/payment-management/account-information': [PERMS.paymentManagement.accountInformation.view],
  '/payment-management/customer-payment-logs': [PERMS.paymentManagement.customerPaymentLogs.list],
} as const;

export const UNRESTRICTED_NAVIGATION_PATHS: ReadonlySet<string> = new Set();
